import { useState, useEffect } from "react";
import { fetchStats } from "../lib/api";

export const useStats = (intervalMs = 5000) => {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const data = await fetchStats();
        if (active) {
          setStats(data);
          setError(false);
        }
      } catch (e) {
        if (active) setError(true);
      }
    };
    load();
    const id = setInterval(load, intervalMs);
    return () => {
      active = false;
      clearInterval(id);
    };
  }, [intervalMs]);

  return { stats, error };
};
